module.exports = __webpack_public_path__ + "static/media/test1_1.415a9fcd.png";